module.exports = __webpack_public_path__ + "static/img/cloud14.b53e17ad.png";